module.exports = __webpack_public_path__ + "static/funeral-7c2c1f2d51cd297d8660d5adf8a24572.svg";